var padStart = function (date) { return String(date).padStart(2, '0'); };
/**
 * Returns the time in YYYY-MM-DD HH:MM:SS format
 */
export var formatEventTime = function (time) {
    var year = time.getFullYear();
    var month = padStart(time.getMonth() + 1);
    var day = padStart(time.getDate());
    var hours = padStart(time.getHours());
    var minutes = padStart(time.getMinutes());
    var seconds = padStart(time.getSeconds());
    return "".concat(year, "-").concat(month, "-").concat(day, " ").concat(hours, ":").concat(minutes, ":").concat(seconds);
};
export var millisecondsToSeconds = function (time) {
    return Math.trunc(time / 1000);
};
export var formatEventVersion = function (remoteConfigVersion, segment) { return "".concat(remoteConfigVersion, ".").concat(segment); };
/**
 * Transforms array of events to the string splited by '\n' character
 * @param events - array of say kit events
 * @returns - string of events
 */
export var stringifyEvents = function (events) { return events.map(function (event) { return JSON.stringify(event); }).join('\n'); };
export var generateRandomId = function () {
    var SYMBOLS = 'qwertyuiopasdfghjklzxcvbnmQWERTYUIOPASDFGHJKLZXCVBNM1234567890';
    var SESSION_ID_LENGTH = 16;
    return Array.from({ length: SESSION_ID_LENGTH }).reduce(function (acc) {
        var index = Math.trunc(Math.random() * SYMBOLS.length);
        return acc + SYMBOLS[index];
    }, '');
};
export var splitArrayToChunks = function (array, length) {
    var slicedArray = [];
    for (var i = 0; i < array.length; i += length) {
        var chunk = array.slice(i, i + length);
        slicedArray.push(chunk);
    }
    return slicedArray;
};
export var validateEventsFromStorage = function (events) {
    if (!Array.isArray(events)) {
        return [];
    }
    return events.filter(function (event) {
        if (typeof event !== 'object' || event === null) {
            return false;
        }
        var requiredKeys = ['time', 'session', 'sequence', 'device_id', 'device_os', 'version', 'event', 'ptime'];
        return requiredKeys.every(function (key) { return key in event; });
    });
};
//# sourceMappingURL=utils.js.map